import { type LanguageCode } from '../features/language/preferences/types';
import { enTranslations } from './locales/en';
import { idTranslations } from './locales/id';
import { type TranslationTree } from './types';

export const i18nResources: Record<LanguageCode, TranslationTree> = {
  en: enTranslations,
  id: idTranslations,
};
